module.exports = __webpack_public_path__ + "static/img/miaoershu.f8ae4b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/miaoershu.jpg
// module id = 7t38
// module chunks = 0